import { get, isFunction } from 'lodash';

export const EMAIL_INTERACTION_TYPE = 'email';
export const GENERAL_NOTE_TYPE = 'general';

const DURATION_ARIA_LABEL_REPLACEMENTS = [
  [/</g, 'Less than'],
  [/>/g, 'More than'],
  [/(\d+)h/g, (match, hour) => `${hour} hour${hour === '1' ? '' : 's'}`],
  [/(\d+)m/g, (match, minute) => `${minute} minute${minute === '1' ? '' : 's'}`],
];

const getInteractionTypeValue = (props = {}) => get(props, 'fields.interaction.type.value', '');
const getDurationFieldOnChange = (props = {}) => get(props, 'fields.interaction.duration.onChange');

const getDurationAriaLabel = (label = '') => DURATION_ARIA_LABEL_REPLACEMENTS.reduce(
  (text, [regex, replacer]) => text.replace(regex, replacer),
  label,
);

export const buildDurationOptions = (durations = []) => durations.map((option) => ({
  ...option,
  ariaLabel: getDurationAriaLabel(option.display_name),
}));

export const buildSubmissionValues = (values = {}) => {
  if (get(values, 'interaction.type') !== EMAIL_INTERACTION_TYPE) {
    return values;
  }

  const interaction = { ...get(values, 'interaction', {}) };
  delete interaction.duration;

  return {
    ...values,
    interaction,
  };
};

export const getDurationFieldClassName = (hideDuration) => `col-sm-4${hideDuration ? ' hidden' : ''}`;

export const shouldShowInteractionHint = (isGeneralNote, hasCases, isFromCaseOrReferral) => (
  (isGeneralNote || !hasCases) && !isFromCaseOrReferral
);

export const syncDurationForInteractionType = (prevProps = {}, props = {}) => {
  const prevType = getInteractionTypeValue(prevProps);
  const currentType = getInteractionTypeValue(props);

  if (prevType === currentType || currentType !== EMAIL_INTERACTION_TYPE) {
    return;
  }

  const onDurationChange = getDurationFieldOnChange(props);

  if (isFunction(onDurationChange)) {
    onDurationChange('');
  }
};
